// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// Libraries
import { Observable, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Service
import { Roles, RolesMap } from '../../modules/auth/models/roles.enum';

// Models
import { AppCleanup, UserModel } from '../models';
import { ErrorRouteData } from '../../modules/error/models/error-route-data.model';

// Store
import { UserAuthState } from '../../modules/auth/state/user-auth.state';

@Injectable()
export class RoleGuard extends AppCleanup {
	@Select(UserAuthState.currentUser) currentUser$: Observable<UserModel>;
	@Select(UserAuthState.currentUserRoleIds) currentUserRoleIds$: Observable<number[]>;

	constructor(private router: Router) {
		super();
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.checkAccess(route);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.checkAccess(route);
	}

	private checkAccess(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return new Observable((obs) => {
			if (this.isViewer) {
				obs.next(true);
			}

			let roles = route.data.roles;

			return this.currentUser$.pipe(takeUntil(this.destroy)).subscribe((currentUser) => {
				if (currentUser) {
					this.currentUserRoleIds$.pipe(takeUntil(this.destroy)).subscribe((userRoles) => {
						if (roles && roles.filter((r) => r in Roles && userRoles.includes(RolesMap[r])).length === 0) {
							let errorRouteData: ErrorRouteData = {
								code: 403,
							};

							this.router.navigate(['/error-page'], { queryParams: errorRouteData });
							obs.next(false);
						}

						obs.next(true);
					});
				}
			});
		});
	}
}
